import { render, staticRenderFns } from "./LectureTrackSubjectLecturesWidget.vue?vue&type=template&id=f30df490&scoped=true"
import script from "./LectureTrackSubjectLecturesWidget.vue?vue&type=script&lang=js"
export * from "./LectureTrackSubjectLecturesWidget.vue?vue&type=script&lang=js"
import style0 from "./LectureTrackSubjectLecturesWidget.vue?vue&type=style&index=0&id=f30df490&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30df490",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f30df490')) {
      api.createRecord('f30df490', component.options)
    } else {
      api.reload('f30df490', component.options)
    }
    module.hot.accept("./LectureTrackSubjectLecturesWidget.vue?vue&type=template&id=f30df490&scoped=true", function () {
      api.rerender('f30df490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/LectureTrackSubjectLecturesWidget.vue"
export default component.exports